module.exports = __webpack_public_path__ + "img/huanhuo8_pc.d66cd45.jpg";